import { TrendingUp, AlertCircle, Shield, Zap } from "lucide-react";

export const ApiSecurityKeyFindings = () => {
  const findings = [
    {
      icon: AlertCircle,
      stat: "94%",
      title: "Applications Have API Vulnerabilities",
      description: "Salt Security research shows the vast majority of production APIs have exploitable security flaws, from broken authentication to excessive data exposure.",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: TrendingUp,
      stat: "681%",
      title: "Increase in API Attacks",
      description: "API attacks have grown exponentially, with malicious traffic now accounting for over 5% of all API calls — a significant jump from previous years.",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Shield,
      stat: "BOLA #1",
      title: "Broken Object Level Authorization",
      description: "BOLA remains the top API vulnerability. Attackers manipulate object IDs to access unauthorized data — often bypassing authentication entirely.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Zap,
      stat: "12 hrs",
      title: "Average Time to Exploit New Vulns",
      description: "Once a vulnerability is disclosed, attackers begin exploitation attempts within hours. Speed of patching is critical for API security.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        The Current State of API Security
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        APIs are the backbone of modern applications, but they're also the most targeted attack surface. 
        Understanding the threat landscape is the first step to building resilient systems.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
